class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.checkBundleConflict();

    if (this.header) this.header.reveal();
    this.open();
  }

  checkBundleConflict() {
    const alertEl = document.getElementById('cart-notification-bundle-alert');
    const checkoutBtn = document.getElementById('cart-notification-checkout');
    if (!alertEl) return;

    Promise.all([
      fetch(window.routes.cart_url + '?section_id=main-cart-items').then(r => r.text()),
      fetch(window.routes.cart_url + '.js').then(r => r.json())
    ])
      .then(([sectionHtml, cart]) => {
        if (!cart.items || cart.items.length === 0) {
          alertEl.style.display = 'none';
          if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
          return;
        }
        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const dataEl = doc.getElementById('bundle-restriction-data');
        let restrictedIds = [];
        if (dataEl) {
          try {
            const brData = JSON.parse(dataEl.textContent);
            restrictedIds = brData.restrictedVariantIds || [];
          } catch (e) {}
        }
        const hasRestricted = restrictedIds.length > 0;
        const hasNormal = cart.items.some(item => !restrictedIds.includes(item.variant_id));
        if (hasRestricted && hasNormal) {
          alertEl.style.display = 'flex';
          if (checkoutBtn) checkoutBtn.setAttribute('disabled', 'disabled');
        } else {
          alertEl.style.display = 'none';
          if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
        }
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
